'use client'
import React, { useContext, useEffect, useState, useRef, Suspense } from 'react'
import Application from '../../StateContext/Application';
import './createticket.css';
import validateFile from '../../../../utils/fileUploadHelper';

const CreateTicket = () => {
    const [form, setForm] = useState({})
    const [data, setData] = useState([])
    const [photo, SetPhoto] = useState("");
    const [documents, SetDocument] = useState("");
    const statecalls = useContext(Application);
    const { RaiseAcomplaint } = statecalls;
    const formref = useRef(null)

    const handleInputChange = (e) => {
        const { id, value } = e.currentTarget;

        // Allow only safe characters (alphanumeric, spaces, etc.) and restrict length
        const safeCharacters = /^[a-zA-Z0-9._-]*$/; // Allow only safe characters for email
        const safeEmailCharacters = /^[a-zA-Z0-9@._-]*$/; // Allow only safe characters for email
        const safePhoneNumber = /^[0-9]*$/; // Allow only safe characters for contact
        const safeName = /^[a-zA-Z/\s]*$/; // Allow only safe characters for name
        const safeAadhar = /^[0-9]*$/; // Allow only safe characters for aadhar
        const safeMessage = /^[a-zA-Z0-9/\s]*$/; // Allow only safe characters for message
        if (!safeEmailCharacters.test(value) && id === 'email') {
            alert("Only safe characters are allowed .");
            return;
        }
        // else if (!safeCharacters.test(value) && id !== 'email') {
        //   alert("Only safe characters are allowed .");
        //   return;
        // }
        else if (!safePhoneNumber.test(value) && id === 'contact') {
            alert("Only Numbers are allowed .");
            return;
        }
        else if (!safeName.test(value) && id === 'fullname') {
            alert("Only safe characters are allowed .");
            return;
        }
        else if (!safeMessage.test(value) && id === 'address') {
            alert("Only safe characters are allowed.");
            return;
        }
        else if (!safeMessage.test(value) && id === 'Message') {
            alert("Only safe characters are allowed.");
            return;
        }
        setForm({ ...form, [id]: value, documents });
    };



    const ImageForm = (e) => {
    const file = e.currentTarget.files[0];
 
    if (!file) return;
 
    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
        alert(validation.message);
        e.currentTarget.value = "";
        return;
    }
 
    const name = file.name;
    const value = e.currentTarget.name;
 
    SetDocument([...documents, { [name]: value }]);
};
    const Document = (e) => {
        let value = e.target.value;
        SetDocument(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // console.log("Submitting form:", form);
        try {
            // Generate an encryption key
            const formData = new FormData();

            // append text fields
            formData.append("ComplaintType", form.ComplaintType);
            formData.append("Message", form.Message);

            // append files
            documents && documents.forEach((item) => {
                const [fileName, inputField] = Object.entries(item)[0];
                const fileInput = document.getElementById(inputField);

                if (fileInput && fileInput.files && fileInput.files[0]) {
                    if (fileName.toLowerCase().includes("pdf")) {
                        formData.append("ApplicationDoc", fileInput.files[0]);
                    } else {
                        formData.append("PhotoDoc", fileInput.files[0]);
                    }
                }
            });

            // Send the encrypted form data and files to the server
            let data = await RaiseAcomplaint(formData);

            if (data.message === "Ticket Created Successfully") {
                alert(data.message);
                // handleclear();
                formref.current.reset();
                setData([]);
            }
        } catch (error) {
            console.log("Error in handleSubmit:", error);
        }
    };

    const handleclear = () => {
        formref.current.reset()
        setData([])
    };
    return (
        <div style={{ backgroundColor: "#d7e6f9" }} className=' h-1'>
            <h2 className='text-center text-3xl  mb-3'>Raise A Ticket</h2>
            <form ref={formref} onSubmit={(x) => handleSubmit(x)} style={{ display: 'flex', width: '80%', flexWrap: "wrap", padding: '2%', borderRadius: '20px', backgroundColor: 'white', marginTop: '14px', margin: "auto" }} autoComplete="off">
                <div className="mx-2" style={{ width: '45%', padding: '8px' }}>
                    <label style={{ fontWeight: 'bold' }}>Complaint Type</label><br />
                    {/* <input autoComplete="off" className="form-control mt-2" accept=".pdf" type="file" name='ApplicationDoc' id="ApplicationDoc" onChange={ImageForm} />
                     */}
                    <select className="form-select mt-2" aria-label="Default select example" name='ComplaintType' id='ComplaintType' onChange={handleInputChange}>
                        <option selected>Select Type</option>
                        <option value="Application Related">Application Related</option>
                        <option value="Financial Related">Financial Related</option>
                        {/* <option value="Gas">Gas</option> */}
                        <option value="Any Other">Any Other</option>
                    </select>
                </div>
                <div className="mx-2" style={{ width: '45%', padding: '8px' }}>
                    <label style={{ fontWeight: 'bold' }}>Your Application(.pdf)</label><br />
                    <input autoComplete="off" className="form-control mt-2" accept=".pdf" type="file" name='ApplicationDoc' id="ApplicationDoc" onChange={ImageForm} />
                </div>
                <div className="mx-2" style={{ width: '45%', padding: '8px' }}>
                    <label style={{ fontWeight: 'bold' }}>Photo(.jpg , .png)</label><br />
                    <input autoComplete="off" className="form-control mt-2" accept="image/png, image/gif, image/jpeg" type="file" name="PhotoDoc" id="PhotoDoc" onChange={ImageForm} />
                </div>
                <div className="mx-2" style={{ width: '100%', padding: '8px' }} >
                    <label style={{ fontWeight: 'bold' }}>Your Message</label><br />
                    <textarea autoComplete="off" id="Message" className="form-control mt-2" onChange={handleInputChange} placeholder="Leave a message..." maxLength={200} required></textarea>
                </div>
                <div className="mx-2" style={{ width: '100%', display: "flex", justifyContent: "space-around" }} >
                    <button type="submit" style={{ width: '8rem', backgroundColor: '#f1772e', color: 'white', borderRadius: '12px' }} className="form-control mt-2 btn  my-2 col-12" >Submit</button>
                    <button type="button" style={{ width: '8rem', border: '2px solid #f1772e', borderRadius: '12px' }} className="form-control mt-2 btn  my-2 col-12" onClick={(e) => { handleclear() }}>Clear</button>
                </div>
            </form>
        </div>
    )
}

export default CreateTicket;